import { CLUSTER, CLUSTER_URL } from '@/constants/app';
import { Ufc } from '@/utils/program/idl/type';
import IDL from '@/utils/program/idl/ufc.json';
import { AnchorProvider, Program } from '@coral-xyz/anchor';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { AnchorWallet } from '@solana/wallet-adapter-react';
import { Connection } from '@solana/web3.js';

export const getProgram = (opts?: {
  wallet?: AnchorWallet;
  connection?: Connection;
}) => {
  const connection =
    opts?.connection ||
    new Connection(CLUSTER_URL, {
      commitment: 'confirmed',
    });
  const provider = new AnchorProvider(connection, opts?.wallet || ({} as any), {
    commitment: 'confirmed',
  });

  const address =
    CLUSTER === WalletAdapterNetwork.Mainnet
      ? 'FGAMEn4Y2CiLhsgifvG658zs2k1yyJ22uWaBJZ1VMwgM'
      : 'DEV8caSxNXscZ4fpnMNLTLvmNzMy8VnPJi3UBg28vuK3';

  return new Program<Ufc>({ ...IDL, address }, provider);
};
